import React from 'react';
import { Component } from "react";

import UserService from "../../services/user.service";
import EventBus from "../../common/EventBus";

type Props = {};

type State = {
  content: string;
}

export default class BoardAdmin extends Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      content: ""
    };
  }

  componentDidMount() {
    UserService.getAdminBoard().then(
      response => {
        this.setState({
          content: response.data
        });
      },
      error => {
        this.setState({
          content:
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString()
        });

        if (error.response && error.response.status === 401) {
          EventBus.dispatch("logout");
        }
      }
    );
  }

  render() {
    return (
      <div>
        <div  className='card-container'>
          <img src="/images/zapiszto.png" alt="general diagram" style={{ width: "100%" }} />
        </div>
        <div  className='card-container'>
          <img src="/images/zapiszto - public.png" alt="database diagram" style={{ width: "100%" }} />
        </div>
      </div>
    );
  }
}
